/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

'use client';

import type { ReactNode } from 'react';
import { useProductView } from '@/providers/product-view';
import ApplePayButton from '../apple-pay-button';

/** Replaces Quick View's Buy It Now fallback when native Apple Pay is available. */
export default function CybersourceApplePayQuickAdd({ children }: { children?: ReactNode }) {
    const { product, currentVariant, canAddToCart } = useProductView();
    const productId = currentVariant?.productId || product.id;

    if (!canAddToCart || !productId) return children;

    return <ApplePayButton context="pdp" sku={productId} className="w-full" fallback={children} />;
}
